<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42"><path fill-rule="evenodd" d="M18 29h-3V14h3v6h6v-6h3v15h-3v-6h-6v6z"/></svg>